import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsSetupWorkItemsComponent } from '../notifications-setup-work-items/notifications-setup-work-items.component';
import {
  NOTIFICATIONS_SETUP_MODAL_DATA,
  NotificationsSetupModalOutput
} from './notifications-setup-modal.modal';

@Component({
  templateUrl: './notifications-setup-modal.component.html',
  styleUrl: './notifications-setup-modal.component.scss',
  imports: [NotificationsSetupWorkItemsComponent]
})
export class NotificationsSetupModalComponent {
  private readonly activeModal = inject(NgbActiveModal);
  protected readonly inputData = inject(NOTIFICATIONS_SETUP_MODAL_DATA);

  protected save(): void {
    const output: NotificationsSetupModalOutput = { action: 'save' };
    this.activeModal.close(output);
  }

  protected close(): void {
    this.activeModal.dismiss();
  }
}
